import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { PortfolioCard } from "@/components/PortfolioShowcase";
import Seo from "@/components/Seo";

const CATS = { all: { de: "Alle", en: "All" }, web: { de: "Web", en: "Web" }, mobile: { de: "Mobile", en: "Mobile" }, software: { de: "Software", en: "Software" } };

export default function Portfolio() {
  const { lang, pickL, t } = useI18n();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/portfolio").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const list = items.filter((p) => (cat === "all" || p.category === cat) && p.active !== false);
  return (
    <div>
      <Seo title={t("home.portfolioTitle")} description={t("home.portfolioSub")} />
      <PageHero eyebrow={t("nav.portfolio")} title={t("home.portfolioTitle")} subtitle={t("home.portfolioSub")} />
      <section className="container-x py-14">
        <div className="flex flex-wrap gap-2 mb-10">
          {Object.keys(CATS).map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`pf-filter-${c}`}
              className={`rounded-full px-5 py-2 text-sm font-semibold border transition-colors ${cat === c ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary"}`}>
              {CATS[c][lang]}
            </button>
          ))}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.04}>
              <PortfolioCard p={p} index={i} />
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
